const isInternalRegex = {
    "envs": {
        "production": /^((https?\:\/\/)?(www)?\.?quickenloans\.com\/?.*)$/,
        "qa": /^((https?\:\/\/)?qa\.quickenloans\.com\/?.*)$/,
        "development": /^((https?\:\/\/)?dev\.quickenloans\.com\/?.*)$/,
        "localhost": /^https?\:\/\/localhost\:[89]000\/?/,
        "local": /^https?\:\/\/(localhost\:[89]000|(dev)?\.?quickenloans\.com)\/?/,
        
    },
};

export default isInternalRegex;